const DEBOUNCE_DELAY = 500;

enum ELoadType {
  IMAGE = 'IMAGE',
  URL = 'URL',
}

enum EImagePickerError {
  SIZE = 'SIZE',
  DIMENSIONS = 'DIMENSIONS',
  ACCEPT = 'ACCEPT',
  FORMAT = 'FORMAT',
  URL = 'URL',
}

type TRestrictions = {
  width?: number;
  height?: number;
  sizeInBytes?: number;
  accept?: string;
  aspectRatio?: number;
  isExactDimensions?: boolean;
};

type TImageDimensions = {
  width: number;
  height: number;
};

type TImageInfo = Partial<TImageDimensions> & {
  name: string;
  url: string;
  format: string;
  size: number;
};

type TContext = {
  imageInfo?: TImageInfo | null;
  isLoading?: boolean;
  urlErrorKey?: string | null;
};

type TImagePickerResult = {
  file: File;
  dimensions?: TImageDimensions;
};

type THandleUploadResult = {
  successUploads: TImagePickerResult[];
  errorUploads: EImagePickerError[];
};

type TCustomValidator = (file: File, dimensions: TImageDimensions) => File | undefined | null;

export {EImagePickerError, ELoadType, DEBOUNCE_DELAY};
export type {
  TRestrictions,
  TImageInfo,
  TImageDimensions,
  TContext,
  TImagePickerResult,
  THandleUploadResult,
  TCustomValidator,
};
